import { calmTokens as t } from '../../shared/tokens';

export default function ForecastCalendarHeader({ totalCount, doneCount }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '36px 0 14px',
        gap: 16,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2
          style={{
            fontFamily: t.fontDisp,
            fontSize: 20,
            fontWeight: 500,
            margin: 0,
            letterSpacing: -0.3,
          }}
        >
          Calendrier du mois
        </h2>
        {totalCount > 0 && (
          <span
            style={{
              padding: '3px 9px',
              fontSize: 11,
              fontFamily: t.fontMono,
              background: t.surface,
              border: `1px solid ${t.border}`,
              borderRadius: 999,
              color: t.textDim,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {totalCount} prévue{totalCount > 1 ? 's' : ''} · {doneCount} effectuée
            {doneCount > 1 ? 's' : ''}
          </span>
        )}
      </div>
    </div>
  );
}
